import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Product from './new-contract/Product';
import Confirmation from './new-contract/Confirmation';
import SignContract from './new-contract/SignContract';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useMediaQuery, useTheme } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import {
  initStep0Data,
  initStep1Data,
  initStep2Data,
} from '../../utils/object/OpenContract';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../redux/create-actions/AlertAction';
import Card from '@mui/material/Card';
import { customerHasCreditCard } from '../../utils/function/Function';
import {
  closeLoadingApi,
  openLoadingApi,
} from '../../redux/create-actions/LoadingAction';
import Color from '../../layouts/Color';
import FontSize from '../../layouts/FontSize';
import { graphCreateNewWay4Contract, graphGetAllContractByCustomer, graphOpenNewContract } from '../../services/Contract';
import { ProductCardType } from '../../enum/Enum.ts';

const useStyles = makeStyles(function (theme) {
  return {
    gridContainer: {
      marginTop: 10,
      [theme.breakpoints.up('xl')]: {
        paddingLeft: ' 150px',
        paddingRight: '150px',
      },
    },
    boxGroupButton: {
      [theme.breakpoints.up("xl")]: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingLeft: ' 200px',
        paddingRight: '200px',
      },
    },
  };
});

const steps = ['Product', 'Confirmation', 'Contract'];

const buttonSubmit = {
  mt: 3, ml: 1,
  color: Color.Button,
  backgroundColor: Color.Main,
  '&:hover': { background: Color.Button, color: Color.Normal }
};
const buttonBack = { mt: 3, ml: 1 };
const paperStyle = { my: { xs: 1, md: 2 }, p: { xs: 1, md: 3 }, minHeight: '100%' };
const steperLabel = {
  '& .MuiStepIcon-root.Mui-active': { color: Color.Main },
  '& .MuiStepLabel-label.Mui-active': { color: Color.Main, fontWeight: 700 },
  '& .Mui-completed': { color: Color.Active, fontWeight: 700 },
  '& .MuiStepIcon-text': { fontSize: FontSize.Tiny }
};
const mainContent = { marginTop: 5 };
const cardStyle = { mt: 2, width: 500 };
const gridContainer = { padding: 2 };

export default function NewContract() {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
  const [activeStep, setActiveStep] = useState(0);
  const classes = useStyles();
  const [step0, setStep0] = useState(initStep0Data(null, null, null));
  const [step1, setStep1] = useState(
    initStep1Data('', '', '', '', '', '', '', '', '', ''),
  );
  const [step1Result, setStep1Result] = useState(null);
  const [step2, setStep2] = useState(initStep2Data());
  const [step2Result, setStep2Result] = useState({});
  const [hasCreditCard, setHasCreditCard] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    graphGetAllContractByCustomer()
      .then((result) => {
        setHasCreditCard(customerHasCreditCard(result));
      })
      .catch((err) => {
        console.log('Error when get check exist credit card: ', err);
      });
  }, []);

  const handleNext = () => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };
    switch (activeStep) {
      case 0:
        if (
          step0.productType !== null &&
          step0.productCode !== '' &&
          step0.productName !== null
        ) {
          setActiveStep(activeStep + 1);
        } else {
          alert = {
            ...alert,
            message: 'You need to select product for opening contract!',
          };
          dispatch(showAlert(alert));
        }
        break;

      case 1:
        let data;
        if (step0.productType === ProductCardType.PREPAID) {
          data = {
            productCode: step0.productCode,
            productCardType: step0.productType,
          };
          dispatch(openLoadingApi());
          let promise = graphOpenNewContract(data);
          promise
            .then((result) => {
              setStep1Result(result);
              dispatch(closeLoadingApi());
              setActiveStep(activeStep + 1);
            })
            .catch(function (error) {
              const err = JSON.parse(JSON.stringify(error))
              alert = { ...alert, message: err.response.errors[0].message };
              dispatch(closeLoadingApi());
              dispatch(showAlert(alert));
            });
        }
        else if (step0.productType === ProductCardType.CREDIT && !hasCreditCard) {
          if (
            !step1.isRefNameError &&
            !step1.isRefPhoneError &&
            step1.refName !== '' &&
            step1.refPhone !== '' &&
            step1.relationship !== ''
          ) {
            data = {
              productCode: step0.productCode,
              productCardType: step0.productType,
              referenceName: step1.refName,
              referencePhone: step1.refPhone,
              relationShip: step1.relationship,
              referenceNote: step1.refNote,
            };
            dispatch(openLoadingApi());
            
            let promise = graphOpenNewContract(data);
            promise
              .then((result) => {
                setStep1Result(result);
                dispatch(closeLoadingApi());
                setActiveStep(activeStep + 1);
              })
              .catch(function (error) {
                const err = JSON.parse(JSON.stringify(error))
                alert = { ...alert, message: err.response.errors[0].message };
                dispatch(closeLoadingApi());
                dispatch(showAlert(alert));
              });
          } else {
            alert = {
              ...alert,
              message: 'You need to input correct information!',
            };
            dispatch(showAlert(alert));
          }
        } else {
          if (
            !step1.isRefNameError &&
            !step1.isRefPhoneError &&
            step1.refName !== '' &&
            step1.refPhone !== '' &&
            step1.relationship !== ''
          ) {
            data = {
              productCode: step0.productCode,
              productCardType: step0.productType,
              referenceName: step1.refName,
              referencePhone: step1.refPhone,
              relationShip: step1.relationship,
              referenceNote: step1.refNote,
            };
            dispatch(openLoadingApi());
            let promise = graphOpenNewContract(data);
            promise
              .then((result) => {
                setStep1Result(result);
                dispatch(closeLoadingApi());
                setActiveStep(activeStep + 1);
              })
              .catch(function (error) {
                const err = JSON.parse(JSON.stringify(error))
                alert = { ...alert, message: err.response.errors[0].message };
                dispatch(closeLoadingApi());
                dispatch(showAlert(alert));
              });
          } else {
            alert = {
              ...alert,
              message: 'You need to input correct information!',
            };
            dispatch(showAlert(alert));
          }
        }
        break;
      case 2:
        if (step2.isAgree === false) {
          alert = {
            ...alert,
            message:
              'Please agree with Apollo terms before submiting contract!',
          };
          dispatch(showAlert(alert));
        } else {
          dispatch(openLoadingApi());
          let promise = graphCreateNewWay4Contract(step1Result.contractId);
          promise
            .then((result) => {
              setStep2Result(result);
              alert = {
                ...alert,
                severity: 'success',
                title: 'Success',
                message: 'Open contract successful!',
              };

              dispatch(showAlert(alert));
              dispatch(closeLoadingApi());
              setActiveStep(activeStep + 1);
            })
            .catch(function (error) {
              const err = JSON.parse(JSON.stringify(error))
              alert = { ...alert, message: err.response.errors[0].message };
              dispatch(closeLoadingApi());
              dispatch(showAlert(alert));
            });
        }
        break;
      default:
        break;
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const getSelectedProduct = (data) => {
    setStep0(data);
  };

  const getAdditionalInformation = (data) => {
    setStep1(data);
  };

  const getAgreeTerms = (data) => {
    setStep2(data);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <Product onUpdateStep0Data={getSelectedProduct} />;
      case 1:
        return (
          <Confirmation
            step0Data={step0}
            onUpdateStep1Data={getAdditionalInformation}
          />
        );
      case 2:
        return (
          <SignContract
            step1Result={step1Result}
            onUpdateStep2Data={getAgreeTerms}
          />
        );
      default:
        throw new Error('Unknown step');
    }
  }

  return (
    <Paper variant="outlined" sx={paperStyle}>
      <Grid container alignItems="center" justifyContent="space-between" sx={{ p: `${matchDownMD ? '20px 20px  5px  20px' : '24px'}` }}>
        <Grid item>
          <Button endIcon={<AddCircleIcon />} sx={{ color: theme.typography.h3, cursor: 'default', fontSize: FontSize.Normal }}>
            Open Contract
          </Button>
        </Grid>
      </Grid>
      <Stepper activeStep={activeStep} alternativeLabel className={classes.gridContainer}>
        {steps.map((label) => (
          <Step key={label} >
            <StepLabel sx={steperLabel}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <React.Fragment>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Grid item sx={mainContent}>
              <Typography variant={matchDownMD ? 'body2' : 'body1'} marked="left" gutterBottom>
                Thank you for your registration.
              </Typography>
              <Typography variant={matchDownMD ? 'body2' : 'body1'}>
                Your contract number is #
                {step2Result.contractNumber
                  ? step2Result.contractNumber
                  : '483946______0275'}
                . We have emailed your contract information and will send you
                the terms during using our services.
              </Typography>
              <Grid
                container
                spacing={3}
                sx={{ mt: 1 }}
                justifyContent="center"
              >
                <Card sx={cardStyle}>
                  <Grid container spacing={3} sx={gridContainer}>
                    <Grid item xs={4} sm={4}>
                      <Typography variant={matchDownMD ? 'body2' : 'body1'}> Contract Name: </Typography>
                    </Grid>
                    <Grid item xs={8} sm={8}>
                      <Typography variant={matchDownMD ? 'body2' : 'body1'}> {step2Result.contractName
                        ? step2Result.contractName
                        : 'Trần Viết Huy'}  </Typography>
                    </Grid>
                    <Grid item xs={4} sm={4}>
                      <Typography variant={matchDownMD ? 'body2' : 'body1'}> Card Number: </Typography>
                    </Grid>
                    <Grid item xs={8} sm={8}>
                      <Typography variant={matchDownMD ? 'body2' : 'body1'}> {step2Result.contractNumber
                        ? step2Result.contractNumber
                        : '483946______0275'} </Typography>
                    </Grid>
                    <Grid item xs={4} sm={4}>
                      <Typography variant={matchDownMD ? 'body2' : 'body1'}> Contract Number: </Typography>
                    </Grid>
                    <Grid item xs={8} sm={8}>
                      <Typography variant={matchDownMD ? 'body2' : 'body1'}> {step2Result.way4Contract
                        ? step2Result.way4Contract
                        : '6730000121170400'} </Typography>
                    </Grid>
                    <Grid item xs={4} sm={4}>
                      <Typography variant={matchDownMD ? 'body2' : 'body1'}> Contract Type: </Typography>
                    </Grid>
                    <Grid item xs={8} sm={8}>
                      <Typography variant={matchDownMD ? 'body2' : 'body1'}> {step2Result.contractType
                        ? step2Result.contractType
                        : 'PREPAID'} </Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {getStepContent(activeStep)}
            <Box className={classes.boxGroupButton}>
              {activeStep !== 0 && (
                <Button onClick={handleBack} sx={buttonBack}>
                  <ArrowBackIosIcon></ArrowBackIosIcon> Back
                </Button>
              )}
              <Button
                variant="contained"
                onClick={handleNext}
                sx={buttonSubmit}
              >
                {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                <NavigateNextIcon></NavigateNextIcon>
              </Button>
            </Box>
          </React.Fragment>
        )}
      </React.Fragment>
    </Paper>
  );
}
